import { IntegrationSettingsBanner } from 'components/shared/banners/IntegrationSettingsBanner';
import useWizard from 'features/wizard/hooks/useWizard';
import useCurrentSubscriptionHelper from 'hooks/billing/useCurrentSubscriptionHelper';
import React from 'react';
import { EmbeddedStatus } from './embedded-status/EmbeddedStatus';
import { MonthlyLabelSummary } from './fulfilled-by-month/MonthlyLabelSummary';
import { usePrimaryProvider } from './hooks/usePrimaryProvider';
import OrderOverview from './OrderOverview';
import OtherInfoCard from './OtherInfoCard';
import ScriptTagsBanner from './ScriptTagsBanner';
import { ShopifyTiles } from './ShopifyTiles';
import { WizardDashboard } from './WizardDashboard';

const DashBoardComponents: React.FC = () => {
    const { currentSubscription, isLoading, isLegacy } = useCurrentSubscriptionHelper();
    const wizardHook = useWizard({ autoOpenFirstUndoneStep: true });
    const { provider: primaryProvider, country: primaryProviderCountry } = usePrimaryProvider();
    const wizardDone = wizardHook.isAllDone();

    return (
        <div className="flex flex-col gap-5">
            {/* <IntercomErrorBanner /> */}
            <div className="flex flex-col gap-4">
                <MonthlyLabelSummary loading={isLoading} hasSubscription={isLoading ? true : !!currentSubscription} />
                <WizardDashboard />
                <OtherInfoCard />
                {wizardDone && <ShopifyTiles provider={primaryProvider} providerCountry={primaryProviderCountry} />}
                <IntegrationSettingsBanner />
                <ScriptTagsBanner />
                {wizardDone && <EmbeddedStatus />}
                <OrderOverview />
            </div>
        </div>
    );
};

export default DashBoardComponents;
